import { TrafficCamsWidget } from './trafficCamsWidget.tsx';

const props = [];

export const TrafficCamsWidgetDirective = reactDirective => reactDirective(TrafficCamsWidget, props);
TrafficCamsWidgetDirective.$inject = ['reactDirective'];

angular.module('WB.App').directive('trafficCamsWidget', TrafficCamsWidgetDirective);
